import { DatePickerInput } from "@/components/frontend/ui/form/inputs/date-picker";
import type { FormVariant } from "@/lib/types/form/form";
import { type FormDateBlock as FormDateBlockT } from "@/payload-types";

type FormDateBlockProps = FormDateBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
	variant?: FormVariant;
};

export const FormDateBlock: React.FC<FormDateBlockProps> = ({
	content,
	settings,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
	variant,
}) => {
	const value = typeof fieldValue === "string" ? fieldValue : "";

	return (
		<DatePickerInput
			name={fieldName}
			value={value}
			onChange={(next) => onFieldChange?.(next)}
			onBlur={onFieldBlur}
			placeholder={content.placeholder ?? undefined}
			label={content.label}
			hideLabel={settings?.hideLabel ?? undefined}
			description={content.description}
			error={fieldError}
			required={content.required ?? false}
			containerClassName={containerClassName}
			autocomplete={settings?.autocomplete ?? undefined}
			monthYearDropdown={settings?.monthYearDropdown ?? false}
			variant={variant}
		/>
	);
};
